import React from "react";
import { Link } from "react-router-dom";
import "./Promotions.css";

const Promotions = () => {
  return (
    <div className="promotions-page text-light p-3">
      {/* Header */}
      <h5 className="promo-header mb-3">
        <Link to="/" className="text-decoration-none text-light">
          <span className="me-2">🏠</span> &gt;{" "}
          <span className="text-warning">Promotions</span>
        </Link>
      </h5>

      {/* Bonus Section */}
      <div className="bonus-section mb-3">
        <div className="bonus-top d-flex justify-content-between align-items-center">
          <div className="bonus-box bg-gradient-red rounded-start flex-grow-1 p-3 me-2">
            <div className="bonus-title">BONUS EARNED</div>
            <div className="bonus-amount">₹X,XXX.XX</div>
          </div>
          <div className="bonus-box bg-gradient-orange rounded-end flex-grow-1 p-3">
            <div className="bonus-title">FREE MONEY EARNED</div>
            <div className="bonus-amount">₹X,XXX.XX</div>
          </div>
        </div>

        <div className="bonus-actions d-flex justify-content-end mt-2">
          <button className="btn btn-dark btn-sm px-3">+ Deposit</button>
        </div>
      </div>

      {/* Lossback Bonus */}
      <div
        className="d-flex align-items-center justify-content-between m-3 rounded"
        style={{
          background: "linear-gradient(90deg, #0b9e52ff 0%, #0c0f0c 100%)",
          color: "white",
          minHeight: "15px",
        }}
      >
        {/* Left Section */}
        <div className="d-flex align-items-center gap-3 w-100">
          <div
            style={{
              fontWeight: "500",
              fontSize: "0.9rem",
              whiteSpace: "nowrap",
              marginLeft: "8px",
            }}
          >
            LOSSBACK BONUS
          </div>

          {/* Progress/Info Bar */}
          <div
            className="flex-grow-1 px-1 py-1 rounded"
            style={{
              background: "rgba(255, 255, 255, 0.08)",
              color: "#d2b48c",
              fontSize: "0.9rem",
            }}
          >
            Login to view claims
          </div>
        </div>

        {/* Right Button */}
        <button
          className="btn btn-success m-2"
          style={{
            borderRadius: "6px",
            padding: "3px",
            whiteSpace: "nowrap",
            fontSize: "0.8rem",
          }}
        >
          VIEW ALL
        </button>
      </div>

      {/* Gift Card */}
      <div className="gift-card-box bg-gradient-purple rounded p-3 mb-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h6 className="mb-0 text-uppercase fw-bold">Gift Card</h6>
          <small className="text-light opacity-75">
            Type or Paste your promocode
          </small>
        </div>
        <div className="d-flex gap-2">
          <input
            type="text"
            className="form-control gift-input"
            placeholder="Enter Promo Code"
          />
          <button className="btn btn-warning fw-bold">Redeem</button>
        </div>
      </div>

      {/* Promos Section */}
      <h5 className="text-white mb-3">Promos</h5>
      <div className="row g-3">
        {[1, 2, 3].map((n) => (
          <div key={n} className="col-12 col-sm-6 col-md-4">
            <div className="promo-card rounded-3 overflow-hidden">
              <img
                src="https://cdn.pixabay.com/photo/2016/03/31/19/56/gift-1294440_1280.png"
                alt="Promo"
                className="promo-img"
              />
              <div className="promo-body p-3">
                <h6 className="text-center mb-2">
                  {n === 3 ? "50%" : "150%"} Bonus On {n}st Deposit
                </h6>
                <button className="btn btn-primary w-100 fw-semibold">
                  Deposit Now
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Promotions;
